<template lang="html">
    <figure class="mb-4 position-relative">
        <FlyerlineModal name="printQ3DModel">
            <div class="modal-content embed-responsive embed-responsive-16/9">
                <iframe :src="this.model3DLangUrl" title="PrintQ 3D Model"  class="embed-responsive-item" id="model3DFrame"></iframe>
            </div>
        </FlyerlineModal>
        <figure class="mb-4 position-relative embed-responsive embed-responsive-218/134">
            <img :src="this.optionPrintQ.customValues.image" @click.prevent="showModal" id="printQProductImage"
                 class="object-fit-contain b-0"/>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="position-absolute xy-center svg-icon--xxlarge icon-no-event"><circle cx="25" cy="25" r="25" fill="#0095d2"/><path d="M42.23,24.31a.67.67,0,0,0-.69.69A16.57,16.57,0,0,1,25,41.54c-7,0-12.48-3.87-15.55-11l2.08.9a.6.6,0,1,0,.5-1.09L8.56,28.76a.35.35,0,0,0-.29-.1H8c-.1.1-.3.2-.3.3h0L6.29,32.62a.6.6,0,0,0,.39.8h.2a.66.66,0,0,0,.59-.4l.8-2.08c3.26,7.63,9.2,11.88,16.73,11.88a18.09,18.09,0,0,0,12.67-5.24A17.69,17.69,0,0,0,42.92,25h0A.67.67,0,0,0,42.23,24.31Z" fill="#fff"/><path d="M43.71,17.38a.6.6,0,0,0-.39-.8h-.2a.66.66,0,0,0-.59.4l-.8,2.08C38.47,11.43,32.53,7.18,25,7.18a18.09,18.09,0,0,0-12.67,5.24A17.69,17.69,0,0,0,7.08,25h0a.69.69,0,1,0,1.38,0A16.57,16.57,0,0,1,25,8.46c7,0,12.48,3.87,15.55,11l-2.08-.9a.6.6,0,1,0-.5,1.09l3.47,1.59h0c.1,0,.19.1.29.1H42c.1,0,.2-.1.3-.2s.1-.1.1-.2Z" fill="#fff"/><path d="M23.14,22.5A2.19,2.19,0,0,1,22.63,24a2.63,2.63,0,0,1-1.45.79v0a2.77,2.77,0,0,1,1.68.69A2,2,0,0,1,23.42,27a2.44,2.44,0,0,1-1,2.06,4.31,4.31,0,0,1-2.69.73,6.09,6.09,0,0,1-2.6-.5V27.94a5.32,5.32,0,0,0,1.25.45,5.2,5.2,0,0,0,1.27.16,2.65,2.65,0,0,0,1.61-.4,1.45,1.45,0,0,0,.53-1.24,1.17,1.17,0,0,0-.59-1.09,3.78,3.78,0,0,0-1.85-.35h-.81V24.26h.82c1.48,0,2.22-.51,2.22-1.54a1.17,1.17,0,0,0-.38-.92,1.79,1.79,0,0,0-1.15-.32,3.38,3.38,0,0,0-1,.15,4.78,4.78,0,0,0-1.16.58l-.73-1a4.85,4.85,0,0,1,3-.94,3.56,3.56,0,0,1,2.19.6A2,2,0,0,1,23.14,22.5Z" fill="#fff"/><path d="M32.82,24.92a4.62,4.62,0,0,1-1.27,3.51,5.14,5.14,0,0,1-3.68,1.21H25.28V20.36h2.87a4.72,4.72,0,0,1,3.44,1.2A4.45,4.45,0,0,1,32.82,24.92Zm-1.6,0q0-3.34-3.11-3.34H26.79v6.74h1.08C30.11,28.37,31.22,27.23,31.22,25Z" fill="#fff"/></svg>
        </figure>
    </figure>
</template>

<script>
import FlyerlineModal from "../fragments/FlyerlineModal.vue";

export const LANG_INDEX = {
  1: 0,
  2: 1,
  4: 2
}

    export default {
      components: {FlyerlineModal},
      inject: ['globalConfig', 'printqService', 'configuratorService'],
      data() {
        return {}
      },
      computed: {
        model3DLangUrl() {
          return this.optionPrintQ.customValues["3dUrl"] + "&lang=" + this.globalConfig.locale.split("_")[0]
        },
        optionPrintQ: function () {
          return this.configuratorService.byConfigoptionType("Printq")
        },
      },
      methods: {
        showModal() {
                this.$modal.show('printQ3DModel')
            }
        },
      watch: {
        optionPrintQ: {
          handler(newVal, oldVal) {
            this.printqService.handleDynamicValuesChanged(oldVal.dynamicValues, newVal.dynamicValues, this.configuratorService)
          }
        }
      },
    };
</script>

<style>
    #model3DFrame {
        height: 100%;
        width: 100%;
    }

    #printQProductImage {
        background-color: white;
        cursor: pointer;
    }
</style>